import { render, staticRenderFns } from "./ContactFormItem.vue?vue&type=template&id=64ccb7ed&scoped=true"
import script from "./ContactFormItem.vue?vue&type=script&lang=js"
export * from "./ContactFormItem.vue?vue&type=script&lang=js"
import style0 from "./ContactFormItem.vue?vue&type=style&index=0&id=64ccb7ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ccb7ed",
  null
  
)

export default component.exports